<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/confirmation/details/', projectId, jobId, confirmationId]">Zurück zur Auftragsbestätigung</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/jobs']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS <cds-icon shape="two-way-arrows"></cds-icon> Confirmation {{ projectId }}.0008.{{ confirmationId }} bearbeiten</h2>
  <app-confirmation-form
    *ngIf="confirmations.length > 0"
    [projectId]="projectId"
    [jobId]="jobId"
    [confirmationId]="confirmationId"
    [confirmationData]="confirmations[0]"
    [isUpdateMode]="true">
  </app-confirmation-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Confirmations:</p>
  {{ confirmations | json }}
</pre>
